import { useContext } from 'react';

import WorkOrderContext from '@atom/components/workOrderDetail/WorkOrderContext';
import { Icon, IconButton } from '@atom/mui';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';

import classes from './taskDetailView.module.css';

const styles = {
  iconButton: {
    width: '1rem',
    height: '1rem',
    padding: '0 0 0.2rem 0',
  },
  icon: {
    fontSize: '1rem',
  },
};

const TaskActualCost = () => {
  const { task } = useContext(WorkOrderContext);

  const tooltipContent = (
    <div className={classes.tooltipContent}>
      <strong>How is Actual Cost calculated?</strong>
      <div>Labor cost + Inventory Cost</div>
    </div>
  );

  const actualCost = hasRolePermissions(ROLE_SETS.MANAGER)
    ? numberToLocaleString(task.actualCost)
    : '-';

  return (
    <div className={classes.costContentRight}>
      <div className={classes.labelContainer}>
        <div className={classes.label}>Actual Cost</div>
        <IconButton tooltip={tooltipContent} style={styles.iconButton}>
          <Icon style={styles.icon}>help</Icon>
        </IconButton>
      </div>
      <div>{actualCost}</div>
    </div>
  );
};

export default TaskActualCost;
